import script from "./HrPopupProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPopupProxy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy});
